import dataService from 'services/dataService';
import { API_PATIENT_KEY_NOTE } from 'services/dataService/resources';
import { showResult } from 'infrastructure/hooks/utils';
import QueryParams from 'utils/queryParams';

import type { ModuleType } from 'infrastructure/enums';

interface IActionsKeyNotesProps {
  patientGuid: string;
  module: ModuleType;
  noteGuid: string;
  showExpired: boolean;
}

export const deleteKeyNotes = async ({
  patientGuid,
  module,
  noteGuid,
  showExpired,
}: IActionsKeyNotesProps) => {
  const baseUrl = API_PATIENT_KEY_NOTE(patientGuid);
  const value: Omit<IActionsKeyNotesProps, 'patientGuid'> = {
    module,
    noteGuid,
    showExpired,
  };

  const url = QueryParams.stringifyUrl(baseUrl, value);

  const { error, data } = await dataService.deleteObject<{ message: string }>(
    url,
    {},
  );

  if (error) {
    showResult(error);
  }

  return data;
};
